export * from "-!../../../../../node_modules/babel-loader/lib/index.js??ref--0-0!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./copyright.vue?vue&type=template&id=0b638ab4&"


//////////////////
// WEBPACK FOOTER
// ./src/js/module/layout/_source/copyright.vue?vue&type=template&id=0b638ab4&
// module id = 508
// module chunks = 30